import React from 'react';
import VideoCard from '../components/LectureCard';
import UploadCard from '../components/UploadCard';

function DisplayLectures({ videos, filteredLectures, search }) {
    const videosToDisplay = search ? filteredLectures : videos;
    console.log(videosToDisplay);

    return (
        <div className="flex flex-wrap -mx-2">
            {search === "" &&
                <div className='max-w-[300px] w-1/3 px-2 mb-4'>
                    <UploadCard/>
                </div>
            }
            {videosToDisplay.map((video, index) => (
                <div className="max-w-[300px] w-1/3 px-2 mb-4" key={index}>
                    <VideoCard {...video} isClip={search} key={video.videoUrl + video.start}/>
                </div>
            ))}
        </div>
    );
};

export default DisplayLectures;
